import { useTranslation } from 'react-i18next';

interface ExternalHelpNoticeProps {
  /** Extra classes on the wrapper, e.g. spacing (`mb-4`) for a given placement. */
  className?: string;
}

/**
 * Shared "cost, agreement and communication are handled outside Etappio" notice
 * for the Extern hjälp surfaces (provider lists, the project's Extern hjälp tab
 * and the "Skicka förfrågan" modal). One component + one i18next key so the
 * wording — which is reviewed legally — changes in a single place. Same styling
 * everywhere (Bootstrap info alert + info icon), `role="note"` for semantics.
 */
export default function ExternalHelpNotice({ className }: ExternalHelpNoticeProps) {
  const { t } = useTranslation();
  return (
    <div
      className={`alert alert-info d-flex align-items-start gap-2${className ? ` ${className}` : ''}`}
      role="note"
    >
      <i className="feather-info flex-shrink-0 mt-1" aria-hidden="true"></i>
      <div>{t('marketplace.request.externalCostNotice')}</div>
    </div>
  );
}
